import { Typography } from '@mui/material'
import ZIcon from '../components/ZIcon'
import { ExitIcon } from '../assets/icons'
import ZScreenContainer from '../components/ZScreenContainer'
import { canReturnToApp, returnToApp } from '../util/notifyHost'
import { SessionStorageKeys } from '../enums'
import ZBottomContainer from '../components/ZBottomContainer'
import ZButton from '../components/ZButton'

const CloseWebApp = ({ deepLinkURI }: { deepLinkURI?: string }) => {
  const authCode = sessionStorage.getItem(SessionStorageKeys.AuthCode)
  const canReturn = canReturnToApp(deepLinkURI)

  return (
    <ZScreenContainer>
      <ZIcon Icon={ExitIcon} title="Exit icon" />

      {canReturn ? (
        <>
          <Typography>
            Please press the button below to return to the app.
          </Typography>

          <ZBottomContainer>
            <ZButton onClick={() => returnToApp(authCode!, deepLinkURI)}>
              Return to the app
            </ZButton>
          </ZBottomContainer>
        </>
      ) : (
        <Typography>Please close this screen.</Typography>
      )}
    </ZScreenContainer>
  )
}

export default CloseWebApp
